const review = () => {
  const clickHandle = () => {
    const reviewSection = document.querySelector('[data-section-type="ProductReviews"]');
    window.scrollTo({
      left: 0,
      top: reviewSection.offsetTop - 50,
      behavior: 'smooth',
    });
  };

  document
    .querySelectorAll('.pdp-c-atc-review-summary__list-stars,.pdp-c-atc-review-summary__count')
    ?.forEach((item) => item.addEventListener('click', clickHandle));
};

export default review;
